import React from "react";

interface BoardTabsProps {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export const BoardTabs: React.FC<BoardTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="educationBoardTabs bg-white p-4 flex justify-center container">
      <div className="bg-[#173CBA] border border-[#7C7C7C] rounded-md px-6 py-3 text-center w-full">
        <h3 className="text-2xl font-normal leading-normal text-white">
          {tabs.map((tab, index) => (
            <span key={tab}>
              <button
                onClick={() => onTabChange(tab)}
                className={`transition-colors duration-200 ${
                  activeTab === tab ? "text-[#0C9]" : "text-white"
                }`}
              >
                {tab}
              </button>
              {index < tabs.length - 1 && (
                <span className="mx-2 text-white">/</span>
              )}
            </span>
          ))}
        </h3>
      </div>
    </div>
  );
};
